type AutoSelectionParams = {
  serviceRequests: any[];
  searchParams: {
    serviceRequestId: string;
    feedback?: string;
  };
};

export const useAutoSelection = ({
  serviceRequests,
  searchParams,
}: AutoSelectionParams): { isAutoSelectionEnabled: boolean } => {
  const hasExistingServiceRequestId = !!searchParams.serviceRequestId;
  const hasFeedbackParam = !!searchParams.feedback;
  const hasServiceRequests = serviceRequests && serviceRequests.length > 0;

  // Only auto-select on completely clean initial load (no serviceRequestId and no feedback param)
  return {
    isAutoSelectionEnabled:
      hasServiceRequests && !hasExistingServiceRequestId && !hasFeedbackParam,
  };
};
